// import { useEffect, useState } from "react";
// import { db } from "../firebase/firebase";
// import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";

// export default function GstInvoicesPage() {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);

//   var navigate = useNavigate();

//   useEffect(() => {
//     const fetchGSTInvoices = async () => {
//       try {
//         const q = query(
//           collection(db, "invoices"),
//           // where("billType", "==", "gst"), // ✅ FILTER GST
//           orderBy("createdAt", "desc") // latest first
//         );

//         const snapshot = await getDocs(q);

//         const list = snapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         setInvoices(list);
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchGSTInvoices();
//   }, []);

//   if (loading) return <div className="text-white">Loading GST invoices...</div>;

//   return (
//     <div className="p-6 text-white">

//       <h1 className="text-2xl font-bold text-orange-500 mb-6">
//         GST Invoices
//       </h1>

//       {invoices.length === 0 ? (
//         <p>No GST invoices found</p>
//       ) : (
//         <div className="overflow-x-auto bg-white/10 rounded-xl p-4">

//           <table className="min-w-full text-sm text-center">
//             <thead className="bg-white/10">
//               <tr>
//                 <th>Invoice No</th>
//                 <th>Name</th>
//                 <th>Amount</th>
//                 <th>GST</th>
//                 <th>Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {invoices.map((inv) => (
//                 <tr key={inv.id} className="border-b border-white/10">

//                   <td className="py-2">{inv.invoiceNo}</td>

//                   <td>{inv.studentName}</td>

//                   <td>₹{inv.amount}</td>

//                   <td>₹{Math.round(inv.gstAmount || 0)}</td>

//                   <td>{inv.date}</td>

//                   <td>
//                     <button onClick={() =>
//                       navigate(`/dashboard/InvoicePreview?inv=${inv.id}`)
//                     } className="text-orange-400 hover:underline">
//                       View
//                     </button>
//                   </td>

//                 </tr>
//               ))}
//             </tbody>

//           </table>

//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function GstInvoicesPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const navigate = useNavigate();

  // 🔥 FETCH DATA
  const fetchGSTInvoices = async () => {
    setLoading(true);
    try {
      let q;

      if (startDate && endDate) {
        q = query(
          collection(db, "invoices"),
          where("createdAt", ">=", new Date(startDate)),
          where("createdAt", "<=", new Date(endDate)),
          orderBy("createdAt", "desc")
        );
      } else {
        q = query(
          collection(db, "invoices"),
          orderBy("createdAt", "desc")
        );
      }

      const snapshot = await getDocs(q);

      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setInvoices(list);
      setSelectedIds([]); // reset selection
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGSTInvoices();
  }, []);

  // ✅ SELECT ONE
  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

  // ✅ SELECT ALL
  const handleSelectAll = () => {
    if (selectedIds.length === invoices.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(invoices.map((inv) => inv.id));
    }
  };

  // 📊 EXPORT TO EXCEL
  const exportToExcel = () => {
    const selectedInvoices = invoices.filter((inv) =>
      selectedIds.includes(inv.id)
    );

    if (selectedInvoices.length === 0) {
      alert("Please select at least one invoice");
      return;
    }

    const data = selectedInvoices.map((inv) => {
      const base = inv.amount / 1.18;
      const gst = inv.amount - base;
      const cgst = gst / 2;
      const sgst = gst / 2;

      return {
        "Invoice No": inv.invoiceNo,
        "Name": inv.studentName,
        "Course": inv.course,
        "Base": base.toFixed(2),
        "CGST (9%)": cgst.toFixed(2),
        "SGST (9%)": sgst.toFixed(2),
        "Total": inv.amount.toFixed(2),
        "Payment Mode": inv.paymentMode,
        "Date": new Date(inv.date).toLocaleDateString("en-IN"),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);

    // ✅ Column width
    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 18 },
      { wch: 15 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "GST Invoices");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, "GST_Invoices.xlsx");
  };

  if (loading) {
    return <div className="text-white p-6">Loading GST invoices...</div>;
  }

  return (
    <div className="p-6 text-white">

      <h1 className="text-2xl font-bold text-orange-500 mb-6">
        GST Invoices
      </h1>

      {/* 🔍 FILTER */}
      <div className="flex gap-4 mb-4 flex-wrap">
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="text-black p-2 rounded"
        />

        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="text-black p-2 rounded"
        />

        <button
          onClick={fetchGSTInvoices}
          className="bg-orange-500 px-4 py-2 rounded"
        >
          Apply Filter
        </button>

        <button
          onClick={exportToExcel}
          className="bg-green-500 px-4 py-2 rounded"
        >
          Export Selected
        </button>
      </div>

      {/* ✅ SELECT COUNT */}
      <p className="mb-3 text-sm">
        Selected: {selectedIds.length} / {invoices.length}
      </p>

      {invoices.length === 0 ? (
        <p>No GST invoices found</p>
      ) : (
        <div className="overflow-x-auto bg-white/10 rounded-xl p-4">

          <table className="min-w-full text-sm text-center">
            <thead className="bg-white/10">
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedIds.length === invoices.length}
                  />
                </th>
                <th>Invoice No</th>
                <th>Name</th>
                <th>Course</th>
                <th>Total</th>
                <th>GST</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {invoices.map((inv) => {
                const base = inv.amount / 1.18;
                const gst = inv.amount - base;

                return (
                  <tr key={inv.id} className="border-b border-white/10">

                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(inv.id)}
                        onChange={() => toggleSelect(inv.id)}
                      />
                    </td>

                    <td className="py-2">{inv.invoiceNo}</td>
                    <td>{inv.studentName}</td>
                    <td>{inv.course}</td>
                    <td>₹{inv.amount}</td>
                    <td>₹{gst.toFixed(2)}</td>
                    <td>{inv.date}</td>

                    <td>
                      <button
                        onClick={() =>
                          navigate(`/dashboard/InvoicePreview?inv=${inv.id}`)
                        }
                        className="text-orange-400 hover:underline"
                      >
                        View
                      </button>
                    </td>

                  </tr>
                );
              })}
            </tbody>

          </table>

        </div>
      )}
    </div>
  );
}